interface Props {
	stepLabel: string
}

const StepChip: React.FC<Props> = ({ stepLabel }) => {
	return (
		<div
			className={`btn btn-sm px-4 py-1 text-kumopack-success-600 border-kumopack-primary-600 w-fit-content`}
			style={{ borderRadius: '16px', borderWidth: '1px', borderStyle: 'solid' }}>
			{stepLabel} 
			{/* <img src="/media/icons/kumopack/blue-chevron-down.svg" alt="Blue Chevron Down" /> */}
		</div>
	)
}

export default StepChip
